import gql from 'graphql-tag';

export const CREATE_FEEDBACK = gql`
  mutation CreateFeedback($input: FeedbackInput!) {
    createFeedback(input: $input) {
      _id
      feedbacks
      category
    }
  }
`;
